export default __webpack_public_path__ + "static/banner-01-3794e233ac9feaf9f52d74ecd0160297.png";